// Block-owned structural types + canonical reference-token regexes for the
// composer. These MIRROR private sources of truth and must stay in lockstep:
//
//   SKILL_REF_RE    ← packages/features/ai/src/skill-refs.ts
//   ARTIFACT_REF_RE ← packages/features/ai/src/artifact-refs.ts
//   part shapes     ← @workspace/ai SkillReferencePart / ArtifactReferencePart
//
// The published package cannot import those private modules; equality is
// enforced by an anti-drift test in @magnus/react
// (src/composer/__tests__/block-refs-sync.test.ts).

/** `{{skill:id|name}}` — group 1 = id, group 2 = name. */
export const SKILL_REF_RE = /\{\{skill:([^|]+)\|([^}]*)\}\}/g;

/** `{{artifact:id|name}}` — group 1 = id, group 2 = name. */
export const ARTIFACT_REF_RE = /\{\{artifact:([^|]+)\|([^}]*)\}\}/g;

/** Structural mirror of the private `SkillReferencePart`. */
export interface SkillReferencePart {
  data: {
    skillId: string;
    skillName: string;
    /** Always set by the serializer ("" when the mention had no slug). */
    skillSlug: string;
    skillDescription?: string;
  };
  type: "data-skill-reference";
}

/** Structural mirror of the private `ArtifactReferencePart`. */
export interface ArtifactReferencePart {
  data: {
    artifactId: string;
    artifactName: string;
    /** Always set by the serializer ("" when the mention had no slug). */
    artifactSlug: string;
  };
  type: "data-artifact-reference";
}

/** A skill offered by the slash-command picker. */
export interface SkillPickerItem {
  /** Grouping key; rendered via `getCategoryLabel` (falls back to the key). */
  category: string;
  skillDescription?: string;
  skillId: string;
  skillName: string;
  skillSlug?: string;
}

/** An artifact offered by the `@`-mention picker. */
export interface ArtifactPickerItem {
  artifactId: string;
  artifactName: string;
  artifactSlug?: string;
}
